<template>
	<LayoutFormInputGeneral :inputId="inputId" :title="title" :subtitle="subtitle" :info="info" :validation="validation">
		<VueDatePicker
				:id="inputId"
				v-model="inputValue"
				range
				locale="es"
				cancelText="Cancelar"
				selectText="Seleccionar"
				:format="format"
				:teleport="true"
				:range="{ maxRange: maxRange ?? null }"
				:enable-time-picker="false"
				:preset-dates="(showPresetDates) ? presetDates : []"
				:placeholder="placeholder"
				@update:modelValue="setMidnight"
				v-focus="focus"
				autocomplete="off" />
	</LayoutFormInputGeneral>
</template>

<script>
	import { ref, watch, onMounted } from 'vue';
	import moment from 'moment';
	import VueDatePicker from '@vuepic/vue-datepicker';

	export default {
		components: { VueDatePicker },
		emits: ['update:from', 'update:to'],
		props: {
			from: [ Date, Object, String ],
			to: [ Date, Object, String ],
			title: String,
			subtitle: String,
			info: String,
			placeholder: String,
			validation: Object,
			defaultRange: Number,
			maxRange: Number,
			showPresetDates: {
				type: Boolean,
				default: true
			},
			focus: {
				type: Boolean,
				default: false
			}
		},
		setup(props, { emit }) {
			const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;
			const inputValue = ref(null);
			const presetDates = ref([
				{
					label: 'Hoy',
					value: [
						moment().startOf('day'),
						moment().endOf('day')
					]
				},
				{
					label: 'Este mes',
					value: [
						moment().startOf('month').startOf('day'),
						moment().endOf('month').endOf('day')
					]
				},
				{
					label: 'Mes anterior',
					value: [
						moment().subtract(1, 'month').startOf('month').startOf('day'),
						moment().subtract(1, 'month').endOf('month').endOf('day')
					]
				}
			]);

			const format = (dates) => {
				let dateFrom = moment(dates[0]),
					dateTo = moment(dates[1]),
					diff = dateTo.diff(dateFrom, 'days') + 1;

				return `${dateFrom.format('DD/MM/YYYY')} - ${dateTo.format('DD/MM/YYYY')} (${diff} ${(diff == 1) ? 'día' : 'días'})`;
			}

			const setMidnight = (selectedDates) => {
				if(selectedDates && selectedDates.length === 2) {
					const dateFrom = moment(selectedDates[0]).startOf('day');
					const dateTo = moment(selectedDates[1]).endOf('day');

					inputValue.value = [ dateFrom, dateTo ];
				}
			}

			watch(inputValue, (newValue) => {
				emit('update:from', (newValue) ? newValue[0] : null);
				emit('update:to', (newValue) ? newValue[1] : null);
			});

			onMounted(() => {
				if(props.from && props.to) inputValue.value = [props.from, props.to];

				if(props.defaultRange > 1) presetDates.value.push({
					label: `Últimos ${props.defaultRange} días`,
					value: [
						moment().subtract(props.defaultRange - 1, 'day').startOf('day'),
						moment().endOf('day')
					]
				});

				if(props.maxRange > 1) presetDates.value.push({
					label: `Últimos ${props.maxRange} días`,
					value: [
						moment().subtract(props.maxRange - 1, 'day').startOf('day'),
						moment().endOf('day')
					]
				});
			});

			return { inputId, inputValue, presetDates, format, setMidnight };
		}
	}
</script>